// Importing necessary types
import { IUserDetailsCommon } from "../../../Types/Common";
import ApiService from "../../ApiService";

enum EducationEndpoints {
  EDUCATON = "/education",
}

// Define the Education class that extends the ApiService class to interact with education-related APIs
class Education extends ApiService {
  // Method to fetch all education details
  async getAllEducations(): Promise<IUserDetailsCommon[]> {
    return this.get<IUserDetailsCommon[]>(EducationEndpoints.EDUCATON);
  }
}

// Creating an instance of Education and exporting it for use in other parts of the application
export const educations = new Education();
